module.exports = __webpack_public_path__ + "static/media/dispatched-active.1de26458.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/dispatched-active.svg
// module id = ./src/assets/icons/dispatched-active.svg
// module chunks = 0